import { each, isEmpty, isUndefined } from 'lodash/fp';
import Mark from 'mark.js';
import { Component } from 'react';
import { connect } from 'react-redux';
import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { ApplicationState } from '@mews-commander/types';
import { SpacingLargeLeftRight, SpacingMediumTopBottom } from '@mews-commander/ui';
import { scrollIntoView } from '@mews-commander/utils';
import { KeyValue } from '@mews/enums';
import { Input } from '@optimus-web/core';
import {
    CloseIcon,
    NextMatchIcon,
    PreviousMatchIcon,
    SearchIcon,
} from '../../../../../modules/search/components/style';
import ActionDropdown from '../../Common/ActionDropdown';

const highlightClassName = 'highlight';
const animationDelay = 200;
const jumpToResult = (index: $TSFixMe, results: $TSFixMe) => {
    const result = results[index];
    each((r) => r.classList.remove(highlightClassName), results);
    if (result) {
        result.classList.add(highlightClassName);
        scrollIntoView(result);
    }
};

interface OwnProps {
    action?: {
        text: string;
    };
}

interface DispatchProps {
    logUsage?: $TSFixMeFunction;
}

type SearchPageActionProps = OwnProps & DispatchProps;

interface SearchPageActionState {
    searchToken: string;
    index: number;
    results: NodeListOf<Element> | never[];
}

class SearchPageAction extends Component<SearchPageActionProps, SearchPageActionState> {
    inputElement: $TSFixMe;
    markjs: $TSFixMe;
    overlay: $TSFixMe;

    state = {
        searchToken: '',
        index: 0,
        results: [],
    };

    modalContainerElementSelector = '';

    componentDidMount() {
        this.modalContainerElementSelector = `#${DEFAULT_PORTAL_ID} .modal-body`;

        const context = document.querySelector(this.modalContainerElementSelector) as HTMLElement;
        this.markjs = new Mark(context);
    }

    getInputRef = (c: $TSFixMe) => (this.inputElement = c);

    getOverlayRef = (c: $TSFixMe) => (this.overlay = c);

    handleToggle = () => {
        this.handleClear();
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.logUsage();

        window.setTimeout(() => {
            if (!isUndefined(this.inputElement)) {
                this.inputElement.focus();
            }
        }, animationDelay);
    };

    handleHideDropdown = () => {
        if (!isUndefined(this.overlay)) {
            this.overlay.handleClose();
            this.handleClear();
        }
    };

    handleSearch = (ev: $TSFixMe, token: $TSFixMe) => {
        this.markjs.unmark({
            done: () => {
                this.markjs.mark(token, {
                    exclude: ['.mews-toolbar', '.btn', '.btn-group', 'no-highlight', '.actions', '.notranslate > span'],
                    separateWordSearch: false,
                    done: () => {
                        const results = document.querySelectorAll(this.modalContainerElementSelector + ' mark');
                        this.setState({
                            results,
                            index: 0,
                        });
                        jumpToResult(0, results);
                    },
                });
            },
        });

        this.setState({
            searchToken: token,
        });
    };

    handleClear = () => {
        this.markjs.unmark();

        this.setState({
            searchToken: '',
            results: [],
            index: 0,
        });
    };

    handleUp = () => {
        this.setState(
            (state) => {
                const newIndex = state.index - 1 >= 0 ? state.index - 1 : state.results.length - 1;
                return {
                    index: newIndex,
                };
            },
            () => {
                jumpToResult(this.state.index, this.state.results);
            }
        );
    };

    handleDown = () => {
        this.setState(
            (state) => {
                const newIndex = state.index + 1 < state.results.length ? state.index + 1 : 0;
                return {
                    index: newIndex,
                };
            },
            () => {
                jumpToResult(this.state.index, this.state.results);
            }
        );
    };

    handleKeyDown = (event: $TSFixMe) => {
        switch (event.key) {
            case KeyValue.ArrowUp:
                event.preventDefault();
                this.handleUp();
                break;
            case KeyValue.ArrowDown:
            case KeyValue.Enter:
                event.preventDefault();
                this.handleDown();
                break;
            case KeyValue.Escape:
                event.preventDefault();
                this.handleHideDropdown();
                break;
            default:
                break;
        }
    };

    render() {
        const rightIcon = isEmpty(this.state.searchToken) ? <SearchIcon /> : <CloseIcon onClick={this.handleClear} />;

        const inputProps = {
            ref: this.getInputRef,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleSearch,
            rightDetail: rightIcon,
            value: this.state.searchToken,
            // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
            placeholder: this.props.action.text,
        };

        const currentResultIndex = this.state.results.length > 0 ? this.state.index + 1 : 0;

        return (
            <ActionDropdown
                componentRef={this.getOverlayRef}
                icon="search"
                // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
                title={this.props.action.text}
                disabled={(this.props.action as $TSFixMe).disabled}
                onOpen={this.handleToggle}
                component={(this.props as $TSFixMe).component}
            >
                <SpacingMediumTopBottom>
                    <SpacingLargeLeftRight>
                        {/* @ts-expect-error $TSFixMeError: Property 'name' is missing in type '{ ref: (c: any) => any; onKeyDown: (event: any) => void; onChange: (ev: any, token: ... */}
                        <Input {...inputProps} />
                        <div className="clearfix">
                            <div className="pull-left">
                                <PreviousMatchIcon onClick={this.handleUp} />
                                <NextMatchIcon onClick={this.handleDown} />
                            </div>
                            <div className="pull-right">{`${currentResultIndex}/${this.state.results.length}`}</div>
                        </div>
                    </SpacingLargeLeftRight>
                </SpacingMediumTopBottom>
            </ActionDropdown>
        );
    }
}

const logUsage =
    () =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { loggerService }: $TSFixMe) => {
        loggerService.log('search-page-action', 'opened', {
            url: window.location.pathname,
        });
    };

export default connect<{}, DispatchProps, OwnProps, ApplicationState>(undefined, {
    logUsage,
})(SearchPageAction);
